import { render, staticRenderFns } from "./TopupsPaymentsComponent.vue?vue&type=template&id=56aed769&"
import script from "./TopupsPaymentsComponent.vue?vue&type=script&lang=js&"
export * from "./TopupsPaymentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports